import type { ReactNode } from "react";

import { cn } from "../lib/utils";
import { Card, CardContent } from "./Card";

/** A labelled headline number, e.g. in a row of dashboard totals. */
export function StatCard({
  label,
  value,
  highlight = false,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  /** Draws attention to a number that needs action. */
  highlight?: boolean;
  className?: string;
}) {
  return (
    <Card
      className={cn(
        highlight ? "border-amber-700 bg-amber-50" : "bg-white",
        className,
      )}
    >
      <CardContent className="px-4 py-2.5">
        <div className="text-xs text-gray-600">{label}</div>
        <div className="text-xl font-semibold text-gray-900 tabular-nums">
          {value}
        </div>
      </CardContent>
    </Card>
  );
}
